import { countryNameByCode } from "../../guest-management/forms/constants";
import { getEventDateTimeComponent } from "../utils";
import { css } from "@emotion/react";
import { theme } from "@minted/minted-components";
import React, { memo } from "react";

const eventDetailMarginStyles = css`
  margin-bottom: ${theme.spacing.x5};
  margin-top: 20px;
`;

export type EventDetailProps = {
  address: string;
  country?: string | null;
  date: string;
  endDate?: string;
  endTime?: string;
  time?: string;
  timezone?: string | null;
  venue?: string | null;
};

const EventDetail = ({
  address,
  country,
  date,
  endDate,
  endTime,
  time,
  timezone,
  venue,
}: EventDetailProps) => (
  <div css={eventDetailMarginStyles}>
    {getEventDateTimeComponent(date, time, endDate, endTime, timezone)}

    {venue && <p>{venue}</p>}

    {address && <p>{address}</p>}

    {country && country !== "US" && <p>{countryNameByCode[country]}</p>}
  </div>
);

const MemoizedEventDetail = memo(EventDetail);

export { MemoizedEventDetail as EventDetail };
